export default {
  heading: 'Thank you for submitting your inquiry!',
  info: 'Your request has been sent!',
  info2: 'All details have been sent to the mailbox provided in the contact form',
  logout: 'Log out',
  newOrder: 'New order',
  download: 'Download offer',
};
